import "regenerator-runtime";
import {
    ComponentProductCategoryConf,
    EquipmentProductCategoryConfiguration,
    EquipmentProductCategorySettings,
    ProductCategory
} from "./equipment/details/settings/EquipmentProductCategorySettings";
import {LastSignOfLife} from "./equipment/details/LastSignOfLife";
import {HierarchyFilter} from "./filters/hierarchies/HierarchyFilter";
import {DashboardContainer} from "./dashboard/DashboardContainer";
// styles
import './styles/main.scss';
import "./styles/main-etui.scss"
import {CheckListFilter} from "./filters/CheckListFilter";
import {EquipmentDashboard} from "./equipment/details/dashboard/EquipmentDashboard";
import {registerLocale} from "react-datepicker";
import {SwitchWrapper, SwitchWrapperProps} from "./components/buttons/SwitchWrapper";
import {Tool} from "./components/toolsbar/ToolsSelector";
import {Granularity, Toolbar} from "./components/toolsbar/Toolbar";
import {InputFilter} from "./filters/InputFilter";
import {StateFilterWithDatepicker} from "./filters/StateFilterWithDatepicker";
import {CompanySearchDefinitionComponent, CompanySuggestion} from "./locations/CompanySearchDefinitionComponent";
import {AppTranslations} from "./components/Utils/translations/AppTranslations";
import {MarketingReports} from "./locations/marketing/MarketingReports";
import {Types} from "./types/Types";
import {AccountRecoveryPage} from "./account/AccountRecoveryPage";
import {EquipmentImages} from "./equipment/details/images/EquipmentImages";
import {EquipmentStockLevel} from "./equipment/details/settings/EquipmentStockLevel";
import {AlarmsGlobalMonitor} from "./dashboard/alarms/AlarmsGlobalMonitor";
import {ComparativeValueFilter} from "./filters/ComparativeValueFilter";
import {StateWithPeriodFilter} from "./filters/StateWithPeriodFilter";
import {PredictiveMaintenanceWizard} from "./equipment/details/PredictiveMaintenanceWizard";
import {AlarmsFilter} from "./equipment/details/alarms/AlarmsFilter";
import {EquipmentAlarmsController} from "./equipment/details/alarms/EquipmentAlarmsController";
import {Haccp} from "./equipment/details/haccp/Haccp";
import {HaccpService} from "./equipment/details/haccp/HaccpService";
import {EquipmentModel} from "./equipment/details/haccp/HaccpController";
import {GlobalSettings} from "./dashboard/settings/GlobalSettings";
import {EquipmentSettings} from "./equipment/details/new_settings/EquipmentSettings";
import {EquipmentStatusFilter} from "./filters/EquipmentStatusFilter";
import {FeedbackModal} from "./feedback/ui/FeedbackModal";
import {Operativity} from "./dashboard/operativity/Operativity";
import {defaultTheme, Theme} from "@vebox/etui-themes";
import {
    danfossWebDarkGrey,
    danfossWebDimGrey,
    danfossWebGrey,
    danfossWebMediumGrey,
    grey60
} from "./styles/global/variables";
import {UserCreation} from "./processes/user_creation/UserCreation";
import {UserManagement} from "./users/UserManagement";
import {FirstLoginPage} from "./account/FirstLoginPage";
import {ChangePasswordPage} from "./account/ChangePasswordPage";
import {MassiveActionsMainPage} from "./processes/massive_actions/MassiveActionsMainPage";
import {ReadAndWrite} from "./ReadAndWrite/ReadAndWrite";
import {CensusCoolerHistoryList} from "./CensusCoolerHistoryList";
import {SWRConfig, SWRConfiguration} from "swr";

export const veboxDefaultTheme: Theme = {
    ...defaultTheme,
    palette: {
        ...defaultTheme.palette,
        action: {
            active: "#46b9f3",
            activeBorder: "#D8D8D9",
            disabled: "#B6BCC1",
            disabledBackground: "#E5E8EB",
            hover: "rgba(234, 235, 236, 0.6)",
            hoverBorder: "rgb(194, 194, 195)",
            disabledOpacity: 0.5,
            hoverOpacity: 0.8,
        },
        black: {10: '#EBEBEB', 20: '#D8D8D9', 40: '#B0B0B1', 60: '#878786', 80: '#575756', 100: '#000000'},
        brand: {light: '#B6000F', main: '#E2000F'},
        common: {white: '#FFFFFF', bg: '#FAFCFC'},
        divider: "#EBEBEB",
        error: {main: '#E2000F'},
        grey: {10: '#F1F3F5', 20: '#E5E8EB', 40: '#CCD3D8', 60: '#B4BCC3', 80: '#9DA7AF', 100: '#869098'},
        info: {main: '#46b9f3'},
        primary: {main: '#303844'},
        secondary: {main: danfossWebMediumGrey},
        success: {main: '#E2000F'},
        text: {primary: '#303844', secondary: '#70767E', disabled: '#869098'},
        tonalOffset: 0.2,
        warning: {main: '#FE8A01'},
    },
};
export const operativityColors = Object.freeze({
    bars: danfossWebMediumGrey,
    bars_hover: veboxDefaultTheme.palette.brand.main,
    percentage: veboxDefaultTheme.palette.brand.main,
    tooltipBg: danfossWebDimGrey,
    percentageOpacity: 0.7,
});

export const themeDefaultValues = {
    // Theme Button
    buttonBg: danfossWebMediumGrey,
    disabledButtonBg: grey60,
    buttonHeight: "42px",
    buttonWidth: "42px",
    buttonTextColor: "white",
    textButtnBorderRadius: "3px",
    buttonPadding: "12px 16px",
    activeButtonColor: danfossWebGrey,

    // Theme Tooltip
    tooltipBg: danfossWebDarkGrey,
    tooltipBorderRadius: "3px",

    //Theme Page
    filtersSectionBg: veboxDefaultTheme.palette.black[80],

    // Theme Viewport
    // @ts-ignore
    viewportBg: this.filtersSectionBg,
};

const enLocale = require("date-fns/locale/en-GB");
const itLocale = require("date-fns/locale/it");
//const csLocale = require("date-fns/locale/cs"); // NOT WORKING LANGUAGE in date-fns
const esLocale = require("date-fns/locale/es");
const frLocale = require("date-fns/locale/fr");
const elLocale = require("date-fns/locale/el");
const huLocale = require("date-fns/locale/hu");
//const plLocale = require("date-fns/locale/pl"); // NOT WORKING LANGUAGE in date-fns
//const ptLocale = require("date-fns/locale/pt"); // NOT WORKING LANGUAGE in date-fns
//const roLocale = require("date-fns/locale/ro"); // NOT WORKING LANGUAGE in date-fns
const ruLocale = require("date-fns/locale/ru");
//const skLocale = require("date-fns/locale/sk"); // NOT WORKING LANGUAGE in date-fns
//const trLocale = require("date-fns/locale/tr"); // NOT WORKING LANGUAGE in date-fns

declare var AppTranslations: AppTranslations;

registerLocale("it-IT", itLocale);
registerLocale("en-GB", enLocale);
registerLocale("cs-CZ", enLocale); // NOT WORKING LANGUAGE in date-fns
registerLocale("es-ES", esLocale);
registerLocale("fr-FR", frLocale);
registerLocale("el-GR", elLocale);
registerLocale("hu-HU", huLocale);
registerLocale("pl-PL", enLocale); // NOT WORKING LANGUAGE in date-fns
registerLocale("pt-PT", enLocale); // NOT WORKING LANGUAGE in date-fns
registerLocale("ro-RO", enLocale); // NOT WORKING LANGUAGE in date-fns
registerLocale("ru-RU", ruLocale);
registerLocale("sk-SK", enLocale); // NOT WORKING LANGUAGE in date-fns
registerLocale("tr-TR", enLocale); // NOT WORKING LANGUAGE in date-fns

const React = require("react");
const ReactDOM = require("react-dom");

declare var require: any;


window.onload = function () {
    (window as any).createNewEquipmentAlarmsController = () => {
        (window as any).equipmentAlarmsController = new EquipmentAlarmsController();
    }
    // Method used for checking if a specific equipment supports Haccp
    (window as any).checkForHaccp = (equipmentID, callback: (exists: boolean) => void) => {
        HaccpService.getEquipmentInfo(equipmentID)
            .then(({equipmentGuid}) => {
                return Promise.all([
                    HaccpService.getEquipmentModel(equipmentGuid)
                        .then((model: EquipmentModel) => model.dummy),
                    HaccpService.getEquipmentDiagnosticsTypes(equipmentGuid, true)
                        .then((result) => result.list)
                        .then((list: any[]) => list.filter((probe) => probe.supportsHaccp))
                        .then((haccpSupportingProbes) => haccpSupportingProbes.length > 0),
                ]);
            })
            .then(([isDummy, isConfigurable]) => {
                return !isDummy && isConfigurable;
            })
            .then(callback)
            .catch(console.error);
    };
    // Method used in the old ts to render React components.
    (window as any).reactRender = ReactDOM.render;
    // Each component that must be created in the old ts must be added here.
    (window as any).rawReactComponents = {
        equipmentAlarmsFilter: (displayCode, useCompletePeriods, defaultFilterConfig) =>
            <AlarmsFilter
                controller={(window as any).equipmentAlarmsController}
                displayCode={displayCode}
                useCompletePeriods={useCompletePeriods}
                defaultFilterConfig={defaultFilterConfig}
            />,
        globalSettings: () =>
            <GlobalSettings/>,
        dashboardEquipmentHaccp: (equipmentID: string) => <Haccp
            equipmentID={equipmentID}
            texts={{
                header: {
                    date: AppTranslations.haccpPageTranslation.datePeriodLabel,
                    today: AppTranslations.haccpPageTranslation.todayOptionLabel,
                    lastWeek: AppTranslations.haccpPageTranslation.lastWeekOptionLabel,
                    lastMonth: AppTranslations.haccpPageTranslation.lastMonthOptionLabel,
                    custom: AppTranslations.haccpPageTranslation.customOptionLabel,
                    from: AppTranslations.alarmsMonitor.texts.from,
                    to: AppTranslations.alarmsMonitor.texts.to,
                    legend: {
                        legend: AppTranslations.haccpPageTranslation.legendTitle,
                        temperature: AppTranslations.haccpPageTranslation.legendTemperatureLabel,
                        deviation: AppTranslations.haccpPageTranslation.legendDeviationLabel,
                        defrost: AppTranslations.haccpPageTranslation.legendDefrostLabel,
                        off: AppTranslations.haccpPageTranslation.legendOffLabel,
                        noData: AppTranslations.haccpPageTranslation.legendNoDataLabel,
                        low: AppTranslations.haccpPageTranslation.lowLabel,
                        high: AppTranslations.haccpPageTranslation.highLabel,
                        edit: AppTranslations.haccpPageTranslation.legendEditLabel
                    },
                    extremesChipButtonLabel: AppTranslations.haccpPageTranslation.extremeButtonLabel
                        ? AppTranslations.haccpPageTranslation.extremeButtonLabel
                        : "Show extremes",
                    exportLabel: AppTranslations.miscellaneous.exportToExcel,
                },
                emptyPage: AppTranslations.haccpPageTranslation.emptyPage,
                emptyPageSub: AppTranslations.errorMessages.tryAgainLaterMessage,
                noHaccpReportAvailable: AppTranslations.haccpPageTranslation.noHaccpReportAvailable,
                table: {
                    diagnostics: AppTranslations.haccpPageTranslation.diagnosticsColoumHead,
                    low: AppTranslations.haccpPageTranslation.lowLabel,
                    high: AppTranslations.haccpPageTranslation.highLabel,
                    editPopupTitle: AppTranslations.haccpPageTranslation.editPopupTitle,
                    editConfirmationButton: AppTranslations.haccpPageTranslation.editPopupConfirmationButtonText,
                    editPopupContent: AppTranslations.haccpPageTranslation.editPopupContentText,
                    createPopupTitle: AppTranslations.haccpPageTranslation.newConfigurationPopupTitle,
                    createConfirmationButton: AppTranslations.haccpPageTranslation.newConfigurationPopupConfirmationButtonText,
                    createPopupContent: AppTranslations.haccpPageTranslation.newConfigurationPopupContentText,
                    deletePopupContentQuestion1: AppTranslations.haccpPageTranslation.deletePopupQuestion1,
                    deletePopupContentQuestion2: AppTranslations.haccpPageTranslation.deletePopupQuestion2,
                    deletePopup: {
                        title: AppTranslations.haccpPageTranslation.deletePopupTitle,
                        cancel: AppTranslations.haccpPageTranslation.deletePopupCancelButtonText,
                        confirm: AppTranslations.haccpPageTranslation.deletePopupConfirmButtonText,
                    },
                    configurationPopup: {
                        thresholdLabel: AppTranslations.haccpPageTranslation.popupThresholdsLabel,
                        maxLabel: AppTranslations.haccpPageTranslation.maxLabel,
                        minLabel: AppTranslations.haccpPageTranslation.minLabel,
                        cancelButtonText: AppTranslations.haccpPageTranslation.popupCancelButtonText,
                        contentTypeLabel: AppTranslations.haccpPageTranslation.popupContentTypeLabel,
                        warning: AppTranslations.haccpPageTranslation.warning ? AppTranslations.haccpPageTranslation.warning : "Recommended thresholds",
                        popupMinThresholdError: AppTranslations.haccpPageTranslation.popupMinThresholdError,
                        popupMaxThresholdError: AppTranslations.haccpPageTranslation.popupMaxThresholdError,
                    },
                    row: {
                        max: AppTranslations.haccpPageTranslation.maxLabel,
                        avg: AppTranslations.haccpPageTranslation.avgLabel,
                        min: AppTranslations.haccpPageTranslation.minLabel,
                        cell: {
                            lo: AppTranslations.haccpPageTranslation.loAbbreviationLabel,
                            hi: AppTranslations.haccpPageTranslation.hiAbbreviationLabel,
                        }
                    }
                }
            }}
        />,
        dashboardLocationHaccp: (locationID: string) => <Haccp
            locationGuid={locationID}
            texts={{
                header: {
                    date: AppTranslations.haccpPageTranslation.datePeriodLabel,
                    today: AppTranslations.haccpPageTranslation.todayOptionLabel,
                    lastWeek: AppTranslations.haccpPageTranslation.lastWeekOptionLabel,
                    lastMonth: AppTranslations.haccpPageTranslation.lastMonthOptionLabel,
                    custom: AppTranslations.haccpPageTranslation.customOptionLabel,
                    from: AppTranslations.alarmsMonitor.texts.from,
                    to: AppTranslations.alarmsMonitor.texts.to,
                    legend: {
                        legend: AppTranslations.haccpPageTranslation.legendTitle,
                        temperature: AppTranslations.haccpPageTranslation.legendTemperatureLabel,
                        deviation: AppTranslations.haccpPageTranslation.legendDeviationLabel,
                        defrost: AppTranslations.haccpPageTranslation.legendDefrostLabel,
                        off: AppTranslations.haccpPageTranslation.legendOffLabel,
                        noData: AppTranslations.haccpPageTranslation.legendNoDataLabel,
                        low: AppTranslations.haccpPageTranslation.lowLabel,
                        high: AppTranslations.haccpPageTranslation.highLabel,
                        edit: AppTranslations.haccpPageTranslation.legendEditLabel,
                    },
                    extremesChipButtonLabel: AppTranslations.haccpPageTranslation.extremeButtonLabel
                        ? AppTranslations.haccpPageTranslation.extremeButtonLabel
                        : "Show extremes",
                    exportLabel: AppTranslations.miscellaneous.exportToExcel,
                },
                emptyPage: AppTranslations.haccpPageTranslation.emptyPage,
                emptyPageSub: AppTranslations.errorMessages.tryAgainLaterMessage,
                noHaccpReportAvailable: AppTranslations.haccpPageTranslation.noHaccpReportAvailable,
                table: {
                    diagnostics: AppTranslations.haccpPageTranslation.diagnosticsColoumHead,
                    low: AppTranslations.haccpPageTranslation.lowLabel,
                    high: AppTranslations.haccpPageTranslation.highLabel,
                    editPopupTitle: AppTranslations.haccpPageTranslation.editPopupTitle,
                    editConfirmationButton: AppTranslations.haccpPageTranslation.editPopupConfirmationButtonText,
                    editPopupContent: AppTranslations.haccpPageTranslation.editPopupContentText,
                    createPopupTitle: AppTranslations.haccpPageTranslation.newConfigurationPopupTitle,
                    createConfirmationButton: AppTranslations.haccpPageTranslation.newConfigurationPopupConfirmationButtonText,
                    createPopupContent: AppTranslations.haccpPageTranslation.newConfigurationPopupContentText,
                    deletePopupContentQuestion1: AppTranslations.haccpPageTranslation.deletePopupQuestion1,
                    deletePopupContentQuestion2: AppTranslations.haccpPageTranslation.deletePopupQuestion2,
                    deletePopup: {
                        title: AppTranslations.haccpPageTranslation.deletePopupTitle,
                        cancel: AppTranslations.haccpPageTranslation.deletePopupCancelButtonText,
                        confirm: AppTranslations.haccpPageTranslation.deletePopupConfirmButtonText,
                    },
                    configurationPopup: {
                        thresholdLabel: AppTranslations.haccpPageTranslation.popupThresholdsLabel,
                        maxLabel: AppTranslations.haccpPageTranslation.maxLabel,
                        minLabel: AppTranslations.haccpPageTranslation.minLabel,
                        cancelButtonText: AppTranslations.haccpPageTranslation.popupCancelButtonText,
                        contentTypeLabel: AppTranslations.haccpPageTranslation.popupContentTypeLabel,
                        warning: AppTranslations.haccpPageTranslation.warning ? AppTranslations.haccpPageTranslation.warning : "Recommended thresholds",
                        popupMinThresholdError: AppTranslations.haccpPageTranslation.popupMinThresholdError,
                        popupMaxThresholdError: AppTranslations.haccpPageTranslation.popupMaxThresholdError,
                    },
                    row: {
                        max: AppTranslations.haccpPageTranslation.maxLabel,
                        avg: AppTranslations.haccpPageTranslation.avgLabel,
                        min: AppTranslations.haccpPageTranslation.minLabel,
                        cell: {
                            lo: AppTranslations.haccpPageTranslation.loAbbreviationLabel,
                            hi: AppTranslations.haccpPageTranslation.hiAbbreviationLabel,
                        }
                    }
                }
            }}
        />,
        dashboardContainer: (stackManager: any) =>
            <DashboardContainer stackManager={stackManager}/>,
        componentLastSignOfLife: (title, componentId) =>
            <LastSignOfLife title={title} componentId={componentId}/>,
        locationsMarketingTab: (filters, goToLocation, viewWidth, isDetailLevel) =>
            <MarketingReports filters={filters} goToLocation={goToLocation} isDetailLevel={isDetailLevel}/>,
        hierarchyFilter: (requestNodesUrl: string, onChange: () => any, defaultValue?: string[]) =>
            <HierarchyFilter nodesUrl={requestNodesUrl} onChange={onChange} defaultValues={defaultValue || []}/>,
        inputFilter: (title: string, onChange: (value: string) => any) =>
            <InputFilter title={title} onChange={onChange}/>,
        telemetrySetupStateFilter: (onChange: (value: string, date: Date) => any) =>
            StateFilterWithDatepicker.telemetrySetupFilter(onChange),
        predictiveMaintenanceWizard: (componentId: number, stackManager: any, alarmId, alarmData: any,
                                      alarmPanel: any) =>
            <PredictiveMaintenanceWizard
                componentId={componentId}
                stackManager={stackManager}
                alarmId={alarmId}
                alarmData={alarmData}
                alarmPanel={alarmPanel}
            />,
        lastSignOfLifeFilter: (currentStatus: string, currentDateOption: string,
                               onChange: (value: string, date: Date) => any) =>
            StateFilterWithDatepicker.lastSignOfLifeFilter(currentStatus, currentDateOption, onChange),
        equipmentProductCategoryChangeSettings: (
            equipmentId: number,
            onOpen: () => any,
            closeOthers: () => any,
            configuration: EquipmentProductCategoryConfiguration,
            productCategories: ProductCategory[],
            componentProductCategoryConfig: ComponentProductCategoryConf,
            allowEditing: boolean,
            equipmentGuid: string,
        ) =>
            <EquipmentProductCategorySettings
                equipmentId={equipmentId}
                onOpen={onOpen}
                closeOthers={closeOthers}
                configuration={configuration}
                productCategories={productCategories}
                componentProductCategoryConfig={componentProductCategoryConfig}
                allowEditing={allowEditing}
                equipmentGuid={equipmentGuid}
            />,
        placementFilter: (selectedPlacements: string[], placementsUrl: string, onChange: () => any) =>
            <CheckListFilter
                selectedElementGuids={selectedPlacements}
                elementsUrl={placementsUrl}
                onChange={onChange}
            />,
        equipmentDashboard: (equipmentId) =>
            <EquipmentDashboard equipmentId={equipmentId}/>,
        companySearchDefinitionComponent: (
            onChangeFunction: (elem: CompanySuggestion) => any,
            hierarchyGuid: string,
            hierarchyLevelIndex: number,
            title: string,
            createNewCompanyTitle: string,
            parentCompanyTitle: string,
        ) =>
            <CompanySearchDefinitionComponent
                title={title}
                allowCompanyCreation={true}
                createNewCompanyTitle={createNewCompanyTitle}
                companyNameTitle={AppTranslations.hierarchies.placeOwnerCompany.companyName}
                companyCodeTitle={AppTranslations.hierarchies.placeOwnerCompany.companyClientCode}
                companyVatTitle={AppTranslations.hierarchies.placeOwnerCompany.companyVat}
                parentCompanyTitle={parentCompanyTitle}
                onChange={onChangeFunction}
                hierarchyGuid={hierarchyGuid}
                hierarchyLevelIndex={hierarchyLevelIndex}
                noElementsFoundText={AppTranslations.hierarchies.noElementsFound}
            />,
        toolbar: (toolsAvailable: Tool[],
                  onBrush: () => any,
                  retrieveData: () => any,
                  timelineExtent: Types.Period,
                  timelineMaxExtent: Types.Period,
                  timelineSelectedPeriod: Types.Period,
                  ref: any,
                  granularities: Granularity[],
                  texts: any) =>
            <Toolbar
                toolsAvailable={toolsAvailable}
                onBrush={onBrush}
                retrieveData={retrieveData}
                timelineExtent={timelineExtent}
                timelineMaxExtent={timelineMaxExtent}
                timelineSelectedPeriod={timelineSelectedPeriod}
                granularities={granularities}
                enabled={false}
                texts={texts}
            />,
        toggleSwitch: (props: SwitchWrapperProps) =>
            <SwitchWrapper
                switchProps={props.switchProps}
                afterChange={props.afterChange}
                uncheckedIconClass={props.uncheckedIconClass}
                checkedIconClass={props.checkedIconClass}
                label={props.label}
            />,
        accountRecoveryPage: (texts) =>
            <AccountRecoveryPage texts={texts}/>,
        equipmentImages: (equipmentId) =>
            <EquipmentImages equipmentId={equipmentId}/>,
        equipmentSettings: (equipmentID, onMount, onSectionMount) => {
            const options: SWRConfiguration = {
                revalidateOnFocus: false,
                revalidateOnReconnect: true,
                revalidateIfStale: true,
                revalidateOnMount: true,
                refreshInterval: 0,
                onError: (error, key) => {
                    console.error("SWR error", error, key);
                    return error;
                }
            }
            return <SWRConfig value={options}>
                <EquipmentSettings
                    equipmentID={equipmentID}
                    onComponentMount={onMount}
                    onSectionMount={onSectionMount}
                />
            </SWRConfig>
        },
        equipmentStock: (equipmentId: number,
                         onOpen: () => any,
                         closeOthers: () => any,
                         onEdit: () => void) =>
            <EquipmentStockLevel equipmentId={equipmentId} onOpen={onOpen} closeOthers={closeOthers} onEdit={onEdit}/>,
        alarmsGlobalMonitor: (filters, goToEquipmentAlarm, useAsFilterFunction, level) =>
            <AlarmsGlobalMonitor
                filters={filters}
                goToEquipmentAlarm={goToEquipmentAlarm}
                useAsFilterFunction={useAsFilterFunction}
                level={level}
            />,
        stockLevelFilter: (
            currentComparator: string,
            currentValue: string,
            onChange: (value: string, comparator: string) => void
        ) =>
            ComparativeValueFilter.stockLevelFilter(
                currentComparator,
                currentValue,
                onChange
            ),
        simpleComparableFilter: (
            currentComparator: string,
            currentValue: string,
            onChange: (value: string, comparator: string) => void
        ) =>
            ComparativeValueFilter.simpleComparableFilter(
                AppTranslations.filters.operativity.percentageFilterTitle,
                currentComparator,
                currentValue,
                onChange
            ),
        equipmentStatusFilter: (onChange: (values: string[]) => void) =>
            <EquipmentStatusFilter
                onChange={onChange}
            />,
        equipmentTargetFilter: (defaultStateOption: string,
                                defaultDateOption: string,
                                onChange: (statusCode: string, startDate: Date, endDate: Date) => void) =>
            StateWithPeriodFilter.equipmentTargetFilter(
                defaultStateOption,
                defaultDateOption,
                defaultStateOption != null && defaultDateOption != null,
                onChange
            ),
        feedbackModal: () => <FeedbackModal/>,
        operativity: (data) => <Operativity data={data}/>,
        userCreationProcess: () => <UserCreation/>,
        massiveActions: (massiveAction, stackManager) => <MassiveActionsMainPage
            massiveAction={massiveAction}
            stackManager={stackManager}
        />,
        readAndWrite: (deviceGuid) => <ReadAndWrite deviceGuid={deviceGuid}/>,
        userList: () => <UserManagement/>,
        censusList: (stackManager: any) => <CensusCoolerHistoryList stackManager={stackManager}/>,
        firstLogin: (texts, token) => <FirstLoginPage texts={texts} token={token}/>,
        changePassword: (texts) => <ChangePasswordPage texts={texts}/>
    }
};
export {ValidatedElementList} from "./processes/massive_actions/models";